const isMongoId = id => !!id.match(/^[0-9a-fA-F]{24}$/);

export { isMongoId };
